import React, { Fragment } from 'react'
import styles from './dot-separated-info.module.scss'
import { ClassNameProps } from 'types/utilities'
import cx from 'classnames'

interface Props extends ClassNameProps {
  infoList: string[]
}

const DotSeparatedInfo = ({ className, infoList }: Props) => {
  return (
    <section className={cx(styles.infoContainer, className)}>
      {infoList.map((info, i) => {
        if (i > 0)
          return (
            <Fragment key={i}>
              <span className={styles.ellipse} aria-hidden></span>
              <p className={styles.info}>{info}</p>
            </Fragment>
          )

        return (
          <p key={i} className={styles.info}>
            {info}
          </p>
        )
      })}
    </section>
  )
}

export default DotSeparatedInfo
